<template>
  <div class="eventos-participantes-sorteo">
    <!-- <app-search-bar/> -->
    
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Datos del Evento">
          <b-form>
            <b-form-group
              label="Cliente"
              label-for="cliente"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cliente"
                :value="clienteNombre"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Evento"
              label-for="evento"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="evento"
                :value="eventoNombre"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
          <b-card header="Listado de Participantes">
            <b-table hover
                responsive="sm" 
                class="registro"
                :busy="tableBusy"
                :items="participantes" 
                :fields="participantesFields" 
                @row-clicked="consultar">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              <template v-slot:cell(orden)="data">
                <template v-if="data.item.orden == 0">
                  ---
                </template>
                <template v-else>
                  {{ data.item.orden | numero(0, false) }}
                </template>
              </template>
              <template v-slot:cell(fechaNacimiento)="data">
                {{ data.item.fechaNacimiento | fecha }}
              </template>
              <template v-slot:cell(staff)="data">
                {{ data.item.staff? 'Si' : 'No' }}
              </template>
            </b-table>
            <nav>
              <b-pagination size="sm" 
                :total-rows="totalRegistros" 
                :per-page="registrosPorPagina" 
                v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
            </nav>
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item
              :disabled="tieneParticipantes"
              @click.stop="importarParticipantes">
            <i class="fa fa-plus"></i>Importar Participantes</b-dropdown-item>

          <b-dropdown-item 
            :disabled="!tieneParticipantes"
            @click.stop="sortear">
          <i class="fa fa-trophy"></i>Sortear</b-dropdown-item>

          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <b-modal ref="importacionModal" 
        title="Importar Participantes"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-importacion
        @close="closeImportacion">
      </app-importacion>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Importacion from './ImportacionSorteo.vue'
import SearchBar from  '../searchList/SearchBar.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import exportXLSParticipantes from '../../mixins/export_xls_participantes';
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'participantesSorteo/getField',
  mutationType: 'participantesSorteo/updateField',
});

export default {
  name: 'ParticipantesSorteo',
  components: {
    appImportacion: Importacion,
    appSearchBar: SearchBar,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal,
    exportXLSParticipantes
  ],
  data: () => {
    return {
      eventoId: 0,

      participantesFields: [
        {
          key: 'orden',
          label: 'Nro.Orden'
        },
        { 
          key: 'nombreCompleto',
          label: 'Nombre'
        },
        { 
          key: 'documentoNumero',
          label: 'Nro.Documento'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
      labelCols: 1,
      editarHabilitado: false,
      borrarHabilitado: false
    }
  },
  computed: {
    ...mapFields([
      'evento',
      'clienteNombre',
      'eventoNombre',
      'tipoEventoId',
      'eventoSorteado',
      'registroManualHabilitado',
      'solicitaCodigoPromocion',
      'participacionNegocios',
      'importaParticipantes',
      'importaGanadores',
      'camposAdicionales',
      'participantesColumnas',

      'participantes',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
    ]),
    tieneParticipantes() {
      if (this.participantes) {
        return (this.totalRegistros > 0);
      }
      return false;
    }
  },
  created() {
    this.eventoId = 0;
    if (this.$route.params){
      if (this.$route.params.eventoId){
        this.eventoId = this.$route.params.eventoId;
      }
    }

    this.showSpinner();
    this.$store.dispatch('participantesSorteo/inicializar', this.eventoId)
      .then(() => {
        this.formatoGrilla();
        // this.getItems();
      })
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner())
  },  
  methods: {
    formatoGrilla() {
      this.participantesFields = [];

      let formatoPropio = false;

      /* ParticipantesColumnas */
      if (this.participantesColumnas) {
        if (this.participantesColumnas.length != 0) {
          formatoPropio = true;

          this.participantesColumnas.forEach(participanteColumna => {
            this.participantesFields.push({ 
              key: participanteColumna.columna,
              label: participanteColumna.titulo
            });
          });
        }
      }
      /* CamposAdicionales */
      if (this.camposAdicionales) {
        if (this.camposAdicionales.length != 0) {
          formatoPropio = true;

          this.camposAdicionales.forEach(campoAdicional => {
            if ((/true/i).test(campoAdicional.incluirListado)) {
              this.participantesFields.push({ 
                key: `cp${campoAdicional.id}`,
                label: campoAdicional.campo
              });
            }
          });
        }
      }

      if (!formatoPropio) {
        if ((/true/i).test(this.solicitaCodigoPromocion)) {
          this.participantesFields.push({
              key: 'codigoPromocion',
              label: 'Cod.Promoción'
            });
        }

        if ((/true/i).test(this.participacionNegocios)) {
          this.participantesFields.push({
              key: 'negocio'
            });
          this.participantesFields.push({
              key: 'negocioCuit',
              label: 'CUIT'
            });
        } else {
          this.participantesFields.push({ 
            key: 'nombreCompleto',
            label: 'Nombre'
          });

          this.participantesFields.push({
            key: 'documentoNumero',
            label: 'Nro.Documento'
          });            
        }
      }
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('participantesSorteo/getParticipantes')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    sortear () {
      this.showModalConfirm('¿Desea realizar el sorteo del evento?', 
            this.sortearEvento, 'Si', null, 'No')
    },
    sortearEvento () {
      this.showSpinner();
      this.$store.dispatch('participantesSorteo/sortear')
        .then(()  => this.showModalMsj('El sorteo se completó éxito.', this.goParticipantes, this.goParticipantes, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())      
    },
    goParticipantes() {
      this.$router.push({ name: 'Participantes', 
                          params: { eventoId: this.eventoId }});
    },
    goBack() {
      if (this.tieneParticipantes) {
        this.showModalConfirm('El listado de participantes importados se eliminará. ¿Desea salir sin realizar el sorteo correspondiente?', 
          this.goParticipantes, 'Si', null, 'No')
      } else {
        this.goParticipantes(-1);
      }
    },
    importarParticipantes() {
      this.$refs.importacionModal.show();
    },
    closeImportacion(params) {
      // console.log(params);
      this.$refs.importacionModal.hide();
      // if ((/true/i).test(params.actualizado)) {
      //   this.getItems();
      // }
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },
  }    
}
</script>

<style>
  /* Staff */
  .eventos-participantes-sorteo tr.table-staff {
    color: var(--primary);
    font-style: italic;
  }
</style>
